// extracted by mini-css-extract-plugin
export default {"imageContainer":"a2-z","summaryPar":"b2-z","ratingCategories":"c2-z","reviewerInfo":"d2-z","reviewTypes":"e2-z","expanded":"f2-z"};